import * as plotUtil from '../plot_util'

export default function (coordinates) {
    if (coordinates.length < 3) return [coordinates];
    let pnt1 = plotUtil.wgsToMercator(coordinates[0]);
    let pnt2 = plotUtil.wgsToMercator(coordinates[1]);
    let pnt3 = plotUtil.wgsToMercator(coordinates[2]);
    let center = plotUtil.getCircleCenterOfThreePoints(pnt1, pnt2, pnt3);
    let radius = plotUtil.distance(pnt1, center);

    let angle1 = plotUtil.getAzimuth(pnt1, center);
    let angle2 = plotUtil.getAzimuth(pnt2, center);
    let startAngle, endAngle;
    if (plotUtil.isClockWise(pnt1, pnt2, pnt3)) {
        startAngle = angle2;
        endAngle = angle1;
    }
    else {
        startAngle = angle1;
        endAngle = angle2;
    }
    let points = plotUtil.getArcPoints(center, radius, startAngle, endAngle);
    return [points];
}